
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Component, Inject, OnInit, Input, EventEmitter, OnDestroy, ViewChild, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionList, MatListOption } from '@angular/material/list';

//app
import { User } from 'solar-bo';
import { ReqFilterHelper } from 'base-models'
import { Site } from 'solar-bo';
import { ListBaseComponent } from '@solar/shared/list-base.component';
import { SortHelper } from 'shtools';
import { SolarService } from '@solar/solar/services/solarservice.service';
import { CountryPickerService, ICountry } from 'basecomponents';
import { tableCol,OptionList } from 'base-models';

@Component({
  selector: 'app-user-sites-list',
  templateUrl: './user-sites-list.component.html'
  ,styleUrls: ['./user-sites-list.component.scss']
})
export class UserSitesListComponent extends ListBaseComponent implements OnInit, OnChanges {

  @Input()userSite: User;
  sites:Site[]=[];
  @Input() sitelist:OptionList[]=[];

  public countries: ICountry[];
  @ViewChild('sites_list') sitesSelectionList: MatSelectionList;
  assignedSites:number=0;
  totalSites:number=0;

 
  constructor(public solarService:SolarService
    ,public countryPickerService :CountryPickerService
) {

      super();
      //const injector = AppInjector.getInjector();
      //const countryPickerService = injector.get(CountryPickerService);
      countryPickerService.getCountries().subscribe(res => this.countries =CountryPickerService.sortCountries(res,"name.common"));
    
  }

  ngOnInit() {
    console.log("ngOnInit dialog", this.dialog);
    this.getSiteList();
    this.statusok = true;
  }


  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName === 'userSite') {
       /*  let parentmodel = changes['userSite'].currentValue;
        this.model = parentmodel; */
        this.asignSites();
      } else {
      }
    }
  }

  sites_list_MatSelectionListChange($event){
    console.log("sites_list_MatSelectionListChange",$event);
    let source:MatSelectionList=$event.source;

    this.assignedSites=source.selectedOptions.selected.length;
  }

  private asignSites(){
    let sitesAssigned=[];
    if (this.userSite.info){
      sitesAssigned=this.userSite.info.sites;
      this.assignedSites=sitesAssigned.length;
      this.sitelist.forEach(element => {
        let option: OptionList =element;
        let isAssigned=sitesAssigned.find(siteid=>siteid==option.value.id);
        if (isAssigned){
          option.selected=true;
        }
      });
    }


  }



  private getSiteList(): void {
    this.listerrmessage = "";
    this.loading = true;
    const filter=[tableCol.id, tableCol.name];
    this.solarService.companySitesGetAll(this.user.company.id,ReqFilterHelper.columnsFilter(filter))
      .subscribe(
        reslist => this.getSiteListhandleresult(reslist)
        , err => this.handleError(err)
      );
  }

  sortByStringLocale(a, b, isAsc?: boolean) {
      console.log("Sort:" + a + " " + b + " local:" +  a.localeCompare(b));
      return new Intl.Collator().compare(a,b);
      //return (a.localeCompare(b) ? -1 : 1) * (isAsc ? 1 : -1);
  }  



  private getSiteListhandleresult(newlist: Site[]) {
    this.listerrmessage = "";
    this.loadinglist = false;
    //newlist = SortHelper.sortMultiple(newlist, ["name"]);

    //newlist= newlist.sort((a,b)=> this.sortByStringLocale(a.name.toLocaleLowerCase(),b.name.toLocaleLowerCase()));
    newlist= newlist.sort((a,b)=> SortHelper.sortByStringLocale(a.name,b.name));


    this.sites = newlist;

    newlist.forEach(element => {
      let option: OptionList = new OptionList(element, false);
      this.sitelist.push(option);
    });

    this.asignSites();

  }

  private getUserSiteListHandleError<T>(err: any) {
    console.log("getListhandleError");
    this.handleError(err, "Error retrieving supervisions list");
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  }


  selectitem(site?: Site) {

  }

  selectionGetSelected():MatListOption[]{
    if (this.sitesSelectionList){
      return this.sitesSelectionList.selectedOptions.selected;
    }     
  }

  uiselectionGetSelectedCount(){
    if (this.sitesSelectionList){
      return this.sitesSelectionList.selectedOptions.selected.length;
    }   
    return 0;  
  }
  uidescription(row:any){
    return row.value.name;
  }
  uigetCountry(row:Site){
    if (!row.info){
      return "";
    }
    return CountryPickerService.uigetCountry(this.countries,row.info.country);
  }

  tableFilter($event){
    
  }
}
